import React, { FC } from "react";
import { Typography } from "@atoms/typography";
import styled from "styled-components";
import { useFHConfig } from "@templates/config";

export interface TrustReasonsData {
  title: string;
  description: string;
  image: string;
}

interface TrustReasonsProps {
  title: string;
  reasons: TrustReasonsData[];
}

export const TrustReasons: FC<TrustReasonsProps> = ({ title, reasons }) => {
  const config = useFHConfig();
  return (
    <Section>
      <Title>{title}</Title>
      <Grid>
        {reasons.map((reason, index) => (
          <Card key={index}>
            <CardContent>
              <CardTitle as={"title3"}>{reason.title}</CardTitle>
              <CardDescription>{reason.description}</CardDescription>
            </CardContent>
            <CardImage src={`${config.backUrl}/assets/${reason.image}`} alt={reason.title} />
          </Card>
        ))}
      </Grid>
    </Section>
  );
};

const Section = styled.section`
  padding: 40px 20px;
  background: #f9f9f9;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 28px;
  margin-bottom: 40px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
  margin-bottom: 60px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Card = styled.div`
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  position: relative;
  @media (min-width: 768px) {
    &:nth-child(even) {
      top: 80px;
      transform: translateX(10px);
    }

    &:nth-child(odd) {
      transform: translateX(-10px);
    }
  }
`;

const CardImage = styled.img`
  width: 100%;
  height: 300px;
  object-fit: cover;
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px;
`;

const CardTitle = styled(Typography)`
  margin: 0 0 8px;
  font-size: 18px;
`;

const CardDescription = styled(Typography)`
  margin: 0;
  font-size: 15px;
  color: #555;
`;
